"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsTab = void 0;
const button_1 = require("client/components/material/button");
const store_1 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_patients_1 = require("../../components/edit-patients");
const store_2 = require("../../store");
require("./patients.less");
let PatientsTab = class PatientsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onSavePatients = (site, patientsAdded, patientsRemoved) => {
            store_2.sitesDetailStore.savePatients(site, patientsAdded, patientsRemoved);
        };
    }
    render() {
        const siteId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "patients__form" },
            store_1.usersStore.permissions.CreatePatient && (React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-patient-btn", to: `/patients/0/${siteId}` },
                React.createElement(Add_1.default, null))),
            React.createElement(edit_patients_1.EditPatients, { error: store_2.sitesDetailStore.editPatients.error, loading: store_2.sitesDetailStore.editPatients.loading, site: siteId ? store_2.sitesDetailStore.site.value : null, status: store_2.sitesDetailStore.editPatients.status, onSave: this.onSavePatients })));
    }
};
PatientsTab = __decorate([
    mobx_react_1.observer
], PatientsTab);
exports.PatientsTab = PatientsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/patients/patients.tsx
// module id = 4046
// module chunks = 0